import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input } from 'antd';
import Captcha from '../../components/Captcha.tsx';
import { captchaConfig } from '../../utils/constants';

@inject('store')
@observer
class Password extends Component {
    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.state = {
            captcha: {
                remoteUrl: captchaConfig.host,
                captchaId: captchaConfig.captchaId,
                onSuccess: this.captchaSuccess.bind(this)
            }
        };
    }

    /**
     * 行为验证码验证成功回调
     * @param result
     */
    captchaSuccess(result) {
        const {
            store: { login }
        } = this.props;

        login.setCaptchaVisible(false);
        const values = this.myForm.current.getFieldsValue(true);

        login.accountLogin(
            {
                ...values,
                captcha_token: result.token
            },
            this.props.type
        );
    }

    onFinish = (values) => {
        const {
            store: { login }
        } = this.props;

        login.accountLogin(values, this.props.type);
    };

    toggleForget = () => {
        const {
            store: { login }
        } = this.props;

        login.setMode('forget');
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return login.activeKey === 'password' ? (
            <>
                <Captcha {...this.state.captcha} show={login.captchaVisible} />
                <Form name="accountLogin" onFinish={this.onFinish} ref={this.myForm}>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: '请输入账号'
                            }
                        ]}
                    >
                        <Input placeholder="请输入手机号/用户名" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        extra={
                            <div
                                style={{
                                    textAlign: 'right',
                                    lineHeight: '24px',
                                    fontSize: '12px',
                                    marginTop: this.props.type === 'competition' ? '10px' : null
                                }}
                            >
                                <a onClick={this.toggleForget}>忘记密码</a>
                            </div>
                        }
                        rules={[
                            {
                                required: true,
                                message: '请输入密码'
                            }
                        ]}
                    >
                        <Input.Password style={{ imeMode: 'disabled' }} placeholder="请输入密码" />
                    </Form.Item>
                    <a> &nbsp;</a>
                    <Form.Item
                        help={
                            <div
                                style={{
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    color: 'rgba(0,0,0,0.25)',
                                    marginTop: '10px'
                                }}
                            >
                                <div>
                                    登录即代表您已经阅读并同意
                                    <a
                                        onClick={() => {
                                            window.open('/privacy_pc');
                                        }}
                                    >
                                        《隐私政策》
                                    </a>
                                    <a
                                        onClick={() => {
                                            window.open('/protocol');
                                        }}
                                    >
                                        《服务协议》
                                    </a>
                                </div>
                                {login.registeredStatus ? <div>非租户学员在登录成功后可注册为租户学员</div> : null}
                            </div>
                        }
                    >
                        <Button type="primary" htmlType="submit" style={{ marginTop: this.props.type === 'competition' ? 0 : '64px' }} block>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </>
        ) : null;
    }
}

export default Password;
